module.exports = __webpack_public_path__ + "static/img/weather30.964ffb08.png";